// Migrated from transition-web/src/components/SignInLanding.tsx
// Updated to use new design system with split-screen layout

import { useNavigate } from 'react-router-dom'
import { useTranslation } from '../shared/hooks/useIntractionTranslate'
import { Box } from '@mui/material'
import { EnvelopeIcon } from '@heroicons/react/24/outline'
import { SignInViewProps } from '../../../pure-js/types/SignInTypes'
import { Button } from '../interaxDesignSystemComponents'
import SignInLandingEmailForm from './SignInLandingEmailForm'
import SignInLayout from './SignInLayout'
import { INTERAX_COLORS } from '../constants/colors'

export default function SignInLanding(props: SignInViewProps) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { inviteMode, inviteOrganizationName } = props

  const headingKey = inviteMode
    ? inviteOrganizationName
      ? 'auth.inviteWelcomeTitleWithOrg'
      : 'auth.inviteWelcomeTitle'
    : 'auth.welcomeTitle'
  const subtitleKey = inviteMode ? 'auth.inviteWelcomeSubtitle' : 'auth.welcomeSubtitle'

  return (
    <SignInLayout backgroundImage="/assets/img/background_login.png">
      <Box className="space-y-8">
        {/* Back Button — hidden in invite mode so the user cannot easily land
            outside the invite acceptance flow before confirming their email. */}
        {!inviteMode && (
          <Box className="flex justify-start">
            <Button variant="link" onClick={() => navigate('/')} className="text-thunder-grey hover:text-white">
              ← Back to Home
            </Button>
          </Box>
        )}

        {/* Header */}
        <Box className="text-center">
          {inviteMode && (
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: '50%',
                backgroundColor: INTERAX_COLORS.sun20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                mb: 2.5
              }}
            >
              <EnvelopeIcon style={{ width: 32, height: 32, color: INTERAX_COLORS.sun }} />
            </Box>
          )}
          <h1 className="text-4xl font-bold text-white mb-4">
            {t(headingKey, inviteMode && inviteOrganizationName ? { orgName: inviteOrganizationName } : undefined)}
          </h1>
          <Box
            component="p"
            sx={{
              fontSize: '18px',
              lineHeight: 1.7,
              color: inviteMode ? INTERAX_COLORS.white70 : INTERAX_COLORS.thunderGrey,
              maxWidth: 560,
              mx: 'auto'
            }}
          >
            {t(subtitleKey)}
          </Box>
        </Box>

        {/* Sign In Form */}
        <Box className="bg-off-black border border-thunder-grey rounded-lg p-8 space-y-6">
          {/* Email Login */}
          <SignInLandingEmailForm {...props} />
        </Box>

        {/* Sign Up Link */}
      </Box>
    </SignInLayout>
  )
}
